<template>
  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn
            icon
            light
            @click="$router.push({ name: 'webmail' })"
            slot="activator"
          >
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title>{{
          $vuetify.t('$vuetify.app.webmail')
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon color="grey lighten-2">delete</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title
          primary-title
          color="blue-grey darken-2"
          class="grey lighten-3"
        >
          <span class="subheading">{{ messageDetail.subject }}</span>
        </v-card-title>
        <v-list three-line color="grey lighten-3">
          <v-list-tile>
            <v-list-tile-avatar color="indigo">
              <span class="white--text title">{{
                messageDetail.from.emailAddress.name
                  .split(' ')
                  .map(i => i.charAt(0))
                  .join('')
              }}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="content">{{
                messageDetail.from.emailAddress.name
              }}</v-list-tile-title>
              <v-list-tile-sub-title class="content body-1"
                >To:
                {{
                  messageDetail.toRecipients[0].emailAddress.name
                }}</v-list-tile-sub-title
              >
              <v-list-tile-sub-title class="content caption">{{
                messageDetail.sentDateTime
              }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="action">
              <v-icon color="grey lighten-1" @click.stop="sheet = true">
                more_horiz
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>
        <v-card v-if="messageDetail.hasAttachments">
          <v-progress-linear
            :indeterminate="true"
            v-if="attachmentsLoading"
            height="24"
            >Loading attachments...</v-progress-linear
          >
          <template v-for="attachment in messageAttachments">
            <v-btn
              v-if="
                messageDetail.hasAttachments && attachment.isInline == false
              "
              color="blue"
              dark
              flat
              left
              :href="
                'data:' +
                  attachment.contenttype +
                  ';base64,' +
                  attachment.contentBytes
              "
              :download="attachment.name"
              class="attachment"
              :key="attachment"
            >
              <v-icon>book</v-icon>
              {{ attachment.name }}
            </v-btn>
          </template>
        </v-card>
        <v-card-text
          v-html="body"
          style="max-width:100vw;overflow:hidden"
        ></v-card-text>
      </v-card>
    </v-flex>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="white" flat>
          <v-btn icon @click="closeReplyDialog()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Reply</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="sendMessage()">
              <v-icon color="blue">
                send
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-flex xs12>
          <v-text-field
            light
            prefix="To:"
            class="pa-1"
            v-model="to"
            value="messageDetail.from.emailAddress.address"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-autocomplete
            v-model="cc"
            :items="contacts"
            :loading="isLoading"
            :search-input.sync="search"
            item-text="scoredEmailAddresses[0].address"
            item-value="scoredEmailAddresses[0].address"
            color="white"
            label="CC"
            return-object
            chips
            clearable
            multiple
            deletable-chips
            small-chips
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            prefix="Subject:"
            class="no-border pa-1"
            :value="'Re:' + messageDetail.subject"
            v-model="subject"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            name="message"
            label="Message"
            auto-grow
            v-model="message"
          ></v-textarea>
        </v-flex>
        <attachments></attachments>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-tile @click="openReplyDialog()">
          <v-list-tile-avatar>
            <v-icon>
              reply
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Reply</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="deleteMessage()">
          <v-list-tile-avatar>
            <v-icon color="red">
              delete
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title class="red--text">Delete</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-layout>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import AttachmentsWrapper from '../components/AttachmentsWrapper'

export default {
  name: 'WebmailShow',
  mixins: [],
  components: {
    attachments: AttachmentsWrapper
  },
  data() {
    return {
      sheet: false,
      dialog: false,
      to: '',
      subject: '',
      cc: '',
      message: '',
      isLoading: false,
      search: null,
      isSelecting: false,
      type: 'reply',
      messageAttachments: [],
      attachmentsLoading: false
    }
  },

  mounted() {
    // const messageDetail = this.getMessageById(this.$route.params.id)
    // if (item.isRead == false) {
    //  this.isRead({ id: item.id, is_read: true })
    // }
  },
  computed: {
    ...mapGetters({
      getMessageById: 'webmail/getMessageById',
      user: 'root/user'
    }),
    ...mapState({
      outbox: state => state.webmail.outbox,
      contacts: state => state.webmail.contacts
    }),
    messageDetail() {
      const messageDetail = this.getMessageById(this.$route.params.id)
      return messageDetail
    }
  },
  watch: {
    messageDetail: function(newVal) {
      this.to = newVal.from.emailAddress.address
      this.subject = 're:' + newVal.subject
      this.body = this.getInlineImages(newVal.body.content)
      if (newVal.isRead == false) {
        this.isRead({ id: newVal.id, is_read: true })
      }
    },
    search(val) {
      this.fetchContactsDebounced(val)
    }
  },
  created() {
    if (this.messageDetail.hasAttachments) {
      const that = this
      this.attachmentsLoading = true
      this.getAttachments({ id: this.$route.params.id }).then(function(
        response
      ) {
        that.messageAttachments = response
        that.attachmentsLoading = false
      })
    }
  },
  methods: {
    ...mapActions({
      readMessages: 'webmail/readMessages',
      sendEmail: 'webmail/sendEmail',
      createReply: 'webmail/createReply',
      deleteReply: 'webmail/deleteReply',
      isRead: 'webmail/isRead',
      getAttachments: 'webmail/getAttachments',
      getContacts: 'webmail/getContacts',
      clearAttachments: 'webmail/clearAttachments'
    }),
    getInlineImages(html) {
      if (this.messageAttachments) {
        for (var x = 0; x < this.messageAttachments.length; x++) {
          html = html.replace(
            'cid:' + this.messageAttachments[x].contentId,
            'data:' +
              this.messageAttachments[x].contentType +
              ';base64, ' +
              this.messageAttachments[x].contentBytes
          )
        }
      }
      return html
    },
    openReplyDialog() {
      this.createReply({ parent_id: this.$route.params.id, attachments: [] })
      this.dialog = true
      this.sheet = false
    },
    closeReplyDialog() {
      this.deleteReply({ parent_id: this.$route.params.id })
      this.dialog = false
      this.clearAttachments()
    },
    sendMessage() {
      const data = {
        to: this.to,
        cc: this.cc,
        subject: this.subject,
        message: this.message,
        user: this.user.imap_username,
        type: this.type,
        attachments: this.outbox ? this.outbox.attachments : [],
        parent_id: this.outbox ? this.outbox.parent_id : null
      }
      this.sendEmail({ data: data })
      this.dialog = false
      this.outbox = []
    },
    fetchContactsDebounced(val) {
      clearTimeout(this._searchTimerId)
      this._searchTimerId = setTimeout(() => {
        this.getContacts({ q: val })
      }, 500) /* 500ms throttle */
    }
  }
}
</script>
<style scoped>
.content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.action {
  min-width: 16px;
  align-items: top;
}
.no-border {
  border-style: none;
}
.no-border.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.no-border.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
input[type='text'] {
  border-bottom: none;
  outline: none;
}
.attachment {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  font-weight: normal;
}
</style>
